"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const normalizeUrl = (url) => url && url.startsWith('assets')
  ? `/${url}`
  : url; exports.normalizeUrl = normalizeUrl

 const DEFAULT_AVATAR_SIZE = 44; exports.DEFAULT_AVATAR_SIZE = DEFAULT_AVATAR_SIZE
 const PALE_PURPLE = "#efeef6"; exports.PALE_PURPLE = PALE_PURPLE

 const ONLINE_BADGE_ICON_ALT_TEXT = 'Active'; exports.ONLINE_BADGE_ICON_ALT_TEXT = ONLINE_BADGE_ICON_ALT_TEXT
 const PATIENT_BADGE_ICON_ALT_TEXT = 'Patient'; exports.PATIENT_BADGE_ICON_ALT_TEXT = PATIENT_BADGE_ICON_ALT_TEXT
 const APP_USER_BADGE_ICON_ALT_TEXT = 'App user'; exports.APP_USER_BADGE_ICON_ALT_TEXT = APP_USER_BADGE_ICON_ALT_TEXT
